// extracted by mini-css-extract-plugin
export var titleContainer = "Dark-module--title-container--2negn";
export var imgContainer = "Dark-module--img-container--2_GDX";
export var contentColumnContainer = "Dark-module--content-column-container--2RyjT";
export var contentColumn = "Dark-module--content-column--3x1IZ";
export var introductionColumn = "Dark-module--introduction-column--ISj5g";
export var tipContainer = "Dark-module--tip-container--59T_w";
export var tipImageContainer = "Dark-module--tip-image-container--2ppvr";
export var tipText = "Dark-module--tip-text--amNJD";